import { render, staticRenderFns } from "./ViewActPage.vue?vue&type=template&id=1acb0b28&scoped=true&"
import script from "./ViewActPage.vue?vue&type=script&lang=js&"
export * from "./ViewActPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewActPage.vue?vue&type=style&index=0&id=1acb0b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acb0b28",
  null
  
)

export default component.exports